// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3463":"3fd4421a","9452":"28e3ac8d"}[chunkId] + ".chunk.css";
};